import React from 'react';

import { Box } from '@wds/box';

import MainHeading from '~pricing/components/MainHeading';
import Navigation from '~pricing/components/Navigation';
import { Package } from '~pricing/components/Summary';
import { PricingData } from '~pricing/lib/summaryPackages';

import useSummaryStyles from './useStyles';
import usePackagesWithCTALabel from '~pricing/hooks/usePackagesWithCTALabel';

export default function PricingSummaryPage({ packageData, packageSet }: PricingData): JSX.Element {
  const { Packages } = useSummaryStyles();
  const { packages } = usePackagesWithCTALabel(packageData, packageSet);

  if (!packageData) {
    return <></>;
  }

  return (
    <>
      <header>
        <MainHeading />
        <Navigation />
      </header>
      <Box className={Packages}>
        {packages?.map(pricingPackage => {
          return <Package {...pricingPackage} key={`package-${pricingPackage.package}`} />;
        })}
      </Box>
    </>
  );
}
